import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ficha-timeline-pagamento-agendado',
  templateUrl: './ficha-timeline-pagamento-agendado.component.html',
  styleUrls: ['./ficha-timeline-pagamento-agendado.component.css']
})
export class FichaTimelinePagamentoAgendadoComponent {
  @Input() timeline: any;
  @Input() timelineActive: boolean;
}
